import { ASSIST_VERSION, formatEth } from '@assist/core';
import { clock } from './controller.js';
import { go, useApp, useRoute } from './hooks.js';
import { t } from './i18n.js';
import { Revoked, SetPin, SignIn, Unlock } from './screens/Auth.js';
import { Failed } from './screens/Failed.js';
import { Followup } from './screens/Followup.js';
import { FullRecord } from './screens/FullRecord.js';
import { Hmis } from './screens/Hmis.js';
import { Home } from './screens/Home.js';
import { Me } from './screens/Me.js';
import { NewbornRegister } from './screens/NewbornRegister.js';
import { Numbers } from './screens/Numbers.js';
import { PatientEdit } from './screens/PatientEdit.js';
import { PatientView } from './screens/PatientView.js';
import { Patients } from './screens/Patients.js';
import { Programme } from './screens/Programme.js';
import { ReferralLetter } from './screens/ReferralLetter.js';
import { Registers } from './screens/Registers.js';
import { Settings } from './screens/Settings.js';
import { Supervisor } from './screens/Supervisor.js';
import { Visit } from './screens/Visit.js';
import { BotNav, Header, Side, useBodyClasses } from './shell.js';

function Body() {
  const a = useApp();
  const r = useRoute();
  switch (a.phase) {
    case 'loading':
      return (
        <div class="boot">
          <span class="spin" aria-hidden="true" />
          {t.loading}
        </div>
      );
    case 'signin':
      return <SignIn />;
    case 'setpin':
      return <SetPin />;
    case 'unlock':
      return <Unlock />;
    case 'revoked':
      return <Revoked />;
    case 'ready':
      break;
  }
  if (r[0] === 'register') return <PatientEdit />;
  if (r[0] === 'patient' && r[1] && r[2] === 'edit') return <PatientEdit id={r[1]} />;
  if (r[0] === 'patient' && r[1] && r[2] === 'visit' && r[3])
    return <Visit key={`${r[1]}/${r[3]}/${r[4] ?? ''}`} id={r[1]} packId={r[3]} formId={r[4]} />;
  if (r[0] === 'patient' && r[1] && r[2] === 'record') return <FullRecord id={r[1]} />;
  if (r[0] === 'patient' && r[1] && r[2] === 'letter')
    return <ReferralLetter id={r[1]} srId={r[3] ?? ''} />;
  if (r[0] === 'patient' && r[1] && r[2] === 'newborn') return <NewbornRegister motherId={r[1]} />;
  if (r[0] === 'patient' && r[1]) return <PatientView id={r[1]} />;
  if (r[0] === 'find') return <Patients />;
  if (r[0] === 'programme' && r[1]) return <Programme code={r[1]} />;
  if (r[0] === 'settings') return <Settings />;
  if (r[0] === 'followup') return <Followup />;
  if (r[0] === 'numbers') return <Numbers />;
  if (r[0] === 'hmis') return <Hmis />;
  if (r[0] === 'registers') return <Registers />;
  if (r[0] === 'supervisor') return <Supervisor />;
  if (r[0] === 'failed') return <Failed />;
  if (r[0] === 'me') return <Me />;
  return <Home />;
}

export function App() {
  const a = useApp();
  const ready = !!(a.phase === 'ready' && a.session);
  useBodyClasses(ready);
  return (
    <>
      {ready ? <Header /> : null}
      {ready ? <Side /> : null}
      <main>
        {a.updateReady ? (
          <div class="banner">
            {t.updateReady}{' '}
            <button type="button" class="sec" onClick={() => location.reload()}>
              {t.reload}
            </button>
          </div>
        ) : null}
        {ready && a.notice ? <div class="banner warn">{a.notice}</div> : null}
        {ready && a.status && a.status.failed > 0 ? (
          <div class="banner warn">
            <button type="button" class="link" onClick={() => go('failed')}>
              {t.failedN(a.status.failed)}: {t.failedTitle}
            </button>
          </div>
        ) : null}
        <Body />
      </main>
      {ready ? <BotNav /> : null}
      <footer class="foot">
        {t.footer} · {formatEth(clock.todayEth())} · {t.version(ASSIST_VERSION)}
      </footer>
    </>
  );
}
